// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../k8-opt-exec/bin/redo/shopify/extension/webpack.bin.runfiles/rules_javascript++yarn+redo_npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../k8-opt-exec/bin/redo/shopify/extension/webpack.bin.runfiles/rules_javascript++yarn+redo_npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._d-0 {\n  display: flex;\n}\n\n._d-1 {\n  flex-direction: row;\n}\n\n._d-2 {\n  flex-direction: column;\n}\n\n._d-3 {\n  flex-direction: row-reverse;\n}\n\n._d-4 {\n  flex-direction: column-reverse;\n}\n\n._d-5 {\n  align-items: center;\n}\n._d-6 {\n  align-items: flex-start;\n}\n._d-7 {\n  align-items: flex-end;\n}\n._d-8 {\n  align-items: stretch;\n}\n._d-9 {\n  align-items: baseline;\n}\n\n._d-a {\n  align-self: center;\n}\n._d-b {\n  align-self: flex-start;\n}\n._d-c {\n  align-self: flex-end;\n}\n._d-d {\n  align-self: stretch;\n}\n._d-e {\n  align-self: baseline;\n}\n\n._d-f {\n  justify-content: center;\n}\n._d-g {\n  justify-content: flex-start;\n}\n._d-h {\n  justify-content: flex-end;\n}\n._d-i {\n  justify-content: space-between;\n}\n._d-j {\n  justify-content: space-around;\n}\n._d-k {\n  justify-content: space-evenly;\n}\n\n._d-l {\n  flex-wrap: wrap;\n}\n\n._d-m {\n  flex-wrap: nowrap;\n}\n\n._d-n {\n  flex-wrap: wrap-reverse;\n}\n", ""]);
// Exports
export var flex = "_d-0";
export var row = "_d-1";
export var column = "_d-2";
export var rowReverse = "_d-3";
export var columnReverse = "_d-4";
export var alignCenter = "_d-5";
export var alignFlexStart = "_d-6";
export var alignFlexEnd = "_d-7";
export var alignStretch = "_d-8";
export var alignBaseline = "_d-9";
export var alignSelfCenter = "_d-a";
export var alignSelfFlexStart = "_d-b";
export var alignSelfFlexEnd = "_d-c";
export var alignSelfStretch = "_d-d";
export var alignSelfBaseline = "_d-e";
export var justifyCenter = "_d-f";
export var justifyFlexStart = "_d-g";
export var justifyFlexEnd = "_d-h";
export var justifySpaceBetween = "_d-i";
export var justifySpaceAround = "_d-j";
export var justifySpaceEvenly = "_d-k";
export var wrapWrap = "_d-l";
export var wrapNowrap = "_d-m";
export var wrapWrapReverse = "_d-n";
export default ___CSS_LOADER_EXPORT___;
